import { render, staticRenderFns } from "./MenuDuJourPanel.vue?vue&type=template&id=1c1380cf&scoped=true&"
import script from "./MenuDuJourPanel.vue?vue&type=script&lang=js&"
export * from "./MenuDuJourPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuDuJourPanel.vue?vue&type=style&index=0&id=1c1380cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1380cf",
  null
  
)

export default component.exports